import React, { useEffect, useRef } from 'react';
import { H4 } from '@components/atoms/typography';

const Poll = ({
  url,
  modalOpen,
  variant
}: {
  url: string;
  modalOpen?: boolean;
  variant: 'mobile' | 'desktop';
}) => {
  const pollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const loadScript = async () => {
      if (!modalOpen && variant === 'mobile') return;
      const postscribe = (await import('postscribe'))?.default;
      if (pollRef.current) {
        postscribe(pollRef.current, `<script src="${url}"></script>`);
      }
    };

    const timeoutId = setTimeout(() => {
      loadScript();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [pollRef, url, modalOpen, variant]);

  return (
    <div id="poll" ref={pollRef}>
      <H4 className="mb-3">Vote</H4>
    </div>
  );
};

export default Poll;
